import mrApi from './mrApi';

export default {
  getMediaObject
};

export function getMediaObject(params) {
  return mrApi.get('/api/media/getMediaObject', { params });
}